<nb-card>
  <nb-card-body>
    <div id="print-section" class="print-layout">
      <div *ngIf="shop.coverUrl" class="logo-bill">
        <img width="100" [src]="shop.coverUrl" alt="" />
      </div>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td style="text-align: center">
            <h4>{{ shop.title }}</h4>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              {{ shop.address }}
            </label>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              ĐT: {{ shop.mobile }}
              <span *ngIf="shop.email"> - Email: {{ shop.email }} </span>
              <span *ngIf="shop.website"> - Web: {{ shop.website }} </span>
            </label>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>

        <tr>
          <td style="text-align: center">
            <h4>
              {{
                receipt.isClosed
                  ? "PHIẾU BÁN HÀNG"
                  : "PHIẾU TẠM TÍNH - KHÔNG XUẤT HÀNG"
              }}
            </h4>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              Ngày:
              {{ receipt.issueDate | date : "dd/MM/yyyy " }}
            </label>
          </td>
        </tr>
        <tr *ngIf="receipt.id.length > 6">
          <td style="text-align: center">
            <label>
              {{ "common.code" | translate }}:
              {{ receipt.id.substring(receipt.id.length - 6, 6) }}
            </label>
          </td>
        </tr>

        <tr>
          <td style="text-align: center">
            <table
              width="100%"
              style="border: 0px"
              cellpadding="0"
              cellspacing="0"
            >
              <tr>
                <td style="text-align: left; width: 60%">
                  <label>
                    <strong> Khách hàng: </strong> {{ receipt.customerName }}
                  </label>
                </td>
                <td style="text-align: left; width: 40%">
                  <label>
                    <strong> ĐT: </strong> {{ receipt.customerMobile }}
                  </label>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="text-align: left">
                  <strong> {{ "common.address" | translate }} : </strong>
                  {{ receipt.customerAddress }}
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>
      </table>

      <table class="table-detail">
        <thead>
          <tr style="text-align: center">
            <th>
              <strong> {{ "common.no" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "product.code" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "product.name" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "product.unit" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "common.quantity" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "common.unitPrice" | translate }} </strong>
            </th>
            <th>
              <strong> Chiết khấu </strong>
            </th>
            <th>
              <strong> {{ "common.totalAmount" | translate }} </strong>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of receipt.receiptDetails; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.productCode }}</td>
            <td style="text-align: left">
              <label>
                {{ item.productName }}
                <span *ngIf="item.comment">( {{ item.comment }} )</span>
              </label>
            </td>
            <td style="text-align: left">
              <label>
                {{ item.productUnitName }}
              </label>
            </td>
            <td style="text-align: right">
              <label>
                {{ item.quantity | number : 0 }}
              </label>
            </td>
            <td style="text-align: right">
              <label>
                {{ item.price | number : 0 }}
              </label>
            </td>
            <td style="text-align: right">
              <label>
                <span *ngIf="item.discountPercent > 0"
                  >{{ item.discountPercent }}% :
                </span>
                {{ item.discountAmount | number : 0 }}
              </label>
            </td>
            <td style="text-align: right">
              {{ item.amount | number : 0 }}
            </td>
          </tr>

          <tr>
            <td colspan="7" style="text-align: right">
              <strong> {{ "common.netAmount" | translate }}: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ receipt.detailAmount | number : 0 }} </strong>
            </td>
          </tr>

          <tr *ngIf="receipt.discountAmount > 0">
            <td colspan="7" style="text-align: right">
              <strong>
                {{ "common.discount" | translate }}
                <span *ngIf="receipt.discountPercent > 0">
                  {{ receipt.discountPercent | number : 0 }}%
                </span>
                :
              </strong>
            </td>
            <td style="text-align: right">
              <strong>
                {{ receipt.discountAmount | number : 0 }}
              </strong>
            </td>
          </tr>

          <tr>
            <td colspan="7" style="text-align: right">
              <strong> {{ "common.totalAmount" | translate }}: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ receipt.totalAmount | number : 0 }} </strong>
            </td>
          </tr>
          <tr *ngIf="receipt.paymentAmount > 0">
            <td colspan="7" style="text-align: right">
              <strong> Thanh toán: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ receipt.paymentAmount | number : 0 }} </strong>
            </td>
          </tr>
          <tr *ngIf="receipt.paymentAmount > 0">
            <td colspan="7" style="text-align: right">
              <strong> Còn nợ: </strong>
            </td>
            <td style="text-align: right">
              <strong>
                {{ receipt.totalAmount - receipt.paymentAmount | number : 0 }}
              </strong>
            </td>
          </tr>
        </tbody>
      </table>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr *ngIf="showDept && receipt.lastDebitAmount != 0">
          <td colspan="3" class="height-1">
            <b>* Nợ đầu ngày:</b> {{ receipt.lastDebitAmount | number }}
          </td>
        </tr>
        <tr *ngIf="showDept && receipt.lastDebitAmount != 0">
          <td colspan="3" class="height-1">
            <b>* Tổng nợ:</b>
            {{
              receipt.lastDebitAmount +
                receipt.totalAmount -
                receipt.paymentAmount | number
            }}
          </td>
        </tr>
        <tr>
          <td colspan="3" class="height-1">
            <b>* Ghi chú:</b> {{ receipt.note }}
          </td>
        </tr>
        <tr>
          <td colspan="3" class="height-1">
            <i>
              - Quý khách vui long kiểm tra mặt cắt, độ dày trước khi sử
              dụng.</i
            ><br />
            <i> - Hàng trả lại phải còn nguyên, không sơn, không biến dạng. </i
            ><br />
            <i> - Chúng tôi chỉ giải quyết đổi trả trong vòng 10 ngày.</i>
          </td>
        </tr>
        <tr>
          <td colspan="3" class="height-1"></td>
        </tr>

        <tr>
          <td style="text-align: center">
            <strong> Người lập phiếu </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>

          <td style="text-align: center">
            <strong> Khách hàng </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>

          <td style="text-align: center">
            <strong> Người xuất kho </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>
        </tr>

        <tr>
          <td style="text-align: center">
            <br />
            <br />
            <br />
            <br />
            <br />
            <span>{{ user?.displayName ? user?.displayName : "" }}</span>
          </td>

          <td style="text-align: center"></td>

          <td style="text-align: center"></td>
        </tr>
      </table>
    </div>
  </nb-card-body>
</nb-card>
